import React from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {Banner} from '/component/base/Banner/Banner';
import Button from '/component/base/Button';
import Text from '/component/base/Text';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './ReassignedBanner.style';

export const ReassignedBanner = () => {
  const {ts, tt} = useTranslation('ReassignmentBanner');
  const {navigate} = useNavigation();

  return (
    <View style={styles.container}>
      <Banner style={{base: styles.base}} verticalBanner alertLevel="info">
        <Text style={styles.accordionTitle} isBold>
          {' '}
          {ts('Accordion Title', 'Candidate has been Reassigned')}
        </Text>

        <View style={styles.accordionBody}>
          <Text style={styles.accordionBody}>
            {tt(
              'candidateReassignedDescription',
              'This Candidate is no longer assigned to you as the 24 hour acceptance window has passed. It has been reassigned to another Coach.',
            )}
          </Text>
          <Button
            testID="backToReportButton"
            onPress={() => navigate('records-main-screen')}
            style={{
              base: styles.reassignedButton,
            }}>
            {ts('ressignment button', 'Back to Candidate Report')}
          </Button>
        </View>
      </Banner>
    </View>
  );
};
